<template>
    <div id="product">
        <el-breadcrumb  separator="/">
            <el-breadcrumb-item  :to="{ path: '/' }" class="text-over clamp1 hidden-sm-and-down">หน้าแรก</el-breadcrumb-item>
            <el-breadcrumb-item   :to="{ path: '/project/1' }" class="text-over clamp1 hidden-sm-and-down">โครงการทุนวัฒนธรรมชุมชนสู่หัตถกรรมล้านนาสร้างสรรค์</el-breadcrumb-item>
            <el-breadcrumb-item   :to="{ path: '/community/1' }" class="text-over clamp1">ศูนย์วัฒนธรรมไทลื้อวัดหย่วน ตำบลหย่วน อำเภอเชียงคำ จังหวัดพะเยา</el-breadcrumb-item>
            <el-breadcrumb-item   class="text-over clamp1">โมเดลตุ๊กตาไทลื้อตั้งโต๊ะ</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 >ผลิตภัณฑ์ “โมเดลตุ๊กตาไทลื้อตั้งโต๊ะ” โดย คุณนัยนา</h1>
        <div class="image-title">
            <el-image
                :src="require('../../assets/product/cp3-9.jpg')" 
                fit="cover"
                :preview-src-list="previewImage"
            />
        </div>
        <div  class="detail">
            <h3>จากการเข้าร่วมโครงการทุนวัฒนธรรมชุมชนสู่หัตถกรรมล้านนาสร้างสรรค์</h3>
            <p >
               ผลิตภัณฑ์ตุ๊กตาไทลื้อได้รับการพัฒนาจากพวงกุญแจตุ๊กตาไทลื้อ ซึ่งเป็นการแต่งตัวตามวัฒนธรรมไทลื้ออย่างมีเอกลักษณ์เฉพาะตัว
            </p>
             <p class="indent">
               🎋ในโครงการ Design Thinking นี้ได้มีการพัฒนาเป็นวิถีชีวิตไทลื้อซึ่งย่อส่วนให้เป็นโมเดลขนาดเล็ก เช่น การหาปลา การหาบของ การฝัดข้าว การตักน้ำ การตำข้าว การปลูกฝ้าย การอีดฝ้าย การแถ่บฝ้าย การกิ๊กฝ้าย การปั่นฝ้าย การเปฝ้าย การย้อมผ้า การแว่นหลอด การทอผ้า และการละเล่นต่างๆ เช่น การขับลื้อ การปั่นรถถีบ การฟ้อนดาบฟ้อนเยิงการขี่ม้ากาบกล้วย การล่กกาบหมาก เล่นกะลาก๊อปแก๊ป การขี่โกงกาง การวิ่งว่าว และการทำอาหารเช่น แอนข้าวควบ แอนข้าวแคบขนมปาด การทำขนมเส้น ดังรูปภาพนี้🌾
            </p>
 
            <h3>การพัฒนาโมเดลวิถีชีวิตไทลื้อที่ผ่านมาแบ่งเป็น 2 ส่วน ดังนี้</h3>
            
            <p class="indent mg-b-less">
                1. การประชาสัมพันธ์ ได้มีการเพิ่มไอเดียในการออกแบบรูปภาพ เช่นเทคนิคใช้การโปรแกรม Snapseed Canva เทคนิคการถ่ายรูปและวีดีโอ
            </p>
            <p class="indent mg-t-less">
                2. ได้รับการพัฒนาตัวผลิตภัณฑ์โมเดลให้มีขนาดเล็กลง ให้เหมาะสำหรับการวางไว้บนโต๊ะทำงาน ในรถและในสถานที่ต่างๆ และได้เพิ่มลายผ้าทอไทลื้อที่กระถางซึ่งอยู่ในตัวโมเดลอีกด้วย
            </p>

            <el-row :gutter="40">
                <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-1.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
                 <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-2.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
            </el-row> 

            <h3>🌟เรื่องราวเกี่ยวกับผู้สร้างสรรค์🌟</h3>
            
            <p class="indent">
                คุณนัยนา วงศ์ใหญ่ หรือพี่กระแต เป็นชาวไทลื้อโดยกำเนิด ในการดำรงชีวิตประจำวันจึงได้เรียนรู้และสะสมประสบการณ์ด้วยตนเอง รวมทั้งการบอกเล่าจากบรรพบุรุษ จึงมีเรื่องราวที่น่าประทับใจและอยากถ่ายทอดให้คนรุ่นใหม่ได้สัมผัสวิถีชีวิตของชาวไทลื้อในอดีต ความภูมิใจที่บรรพบุรุษได้ถ่ายทอดให้ลูกหลานคือความขยัน อดทนและต่อสู้ชีวิต เช่น การปลูกข้าว-พืชผักไว้กินเอง การหากุ้งหอยปูปลา การปลูกฝ้าย อีดฝ้าย และกระบวนทอผ้าเพื่อใช้เป็นเครื่องนุ่มห่มเอง ตลอดจนการบะเล่นต่างๆ ที่ควรอนุรักษ์ไว้ เช่น นั่งกาบหมาก เล่นขี่ม้าก้านกล้วย เล่นว่าว เล่นกะลาก๊อปแก๊ป ฟ้อนดาบฟ้อนเจิง การขับลื้อ มีอาหารพื้นบ้านไทลื้อ เช่น แอ่งแทะ ขนมเส้น ขนมปาดข้าวแคบ ข้าวควบ เป็นต้น ดังนั้นจึงได้ถ่ายทอดออกมาในรูปแบบโมเดลวิถีชีวิตไทลื้อชุดต่างๆ ให้น่ารักสวยงาม มีเอกลักษณ์เป็นของตัวเอง
            </p>

            <el-row :gutter="40">
                <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-3.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
                 <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-4.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
            </el-row> 

            <h3>❤️ฝากใจไว้ให้ทีมงาน❤️</h3>
            
            <p class="indent">
                เมื่อมีโครงการ Design Thinking ของมหาวิทยาลัยพะเยาเข้ามาช่วยเหลือ ได้รับการแนะนำจากครูน้อง หรือคุณหทัยทิพย์ เชื้อสะอาด (นักสื่อสารชุมชนไทลื้อวัดหย่วน) จึงอยากเรียนรู้เพื่อเสริมประสบการณ์ให้โมเดลวิถีชีวิตไทลื้อมีการพัฒนามากยิ่งขึ้น และดีใจมากที่ได้เรียนรู้จากอาจารย์อั้มและทีมงานที่มีความรู้และประสบการณ์ให้ผู้เรียนในศูนย์วัฒนธรรมไทลื้อวัดหย่วนได้รับโอกาสในครั้งนี้
            </p>

            <el-row :gutter="40">
                <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-5.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
                 <el-col  :xs="24" :sm="12" >
                    <div class="card-product">
                        <el-image
                            :src="require('../../assets/product/cp3-6.jpg')" 
                            fit="cover"
                            :preview-src-list="previewImage"
                        />
                    </div>
                </el-col>
            </el-row> 

            <p>นับว่าทางผู้เรียนได้รับประโยชน์อย่างมากในการเข้าร่วมโครงการในครั้งนี้ และจะนำเป็นพัฒนาให้ดียิ่งขึ้นด้วยค่ะ</p>

            <p class="mg-b-less">จึงขอขอบคุณคณะอาจารย์จากมหาวิทยาลัยพะเยาเป็นอย่างยิ่งมา ณ โอกาสนี้ด้วยนะคะ</p>

            <div class="video">
                <video width="650" height="450"   controls>
                    <source :src="require('../../assets/video/cp3.mp4')" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>

            <h3>ช่องทางการติดต่อหรือสนใจสั่งสินค้าได้ตามลิงค์นี้ค่ะ</h3>
            <a target="_blank" href="https://www.facebook.com/%E0%B8%95%E0%B8%B8%E0%B9%8A%E0%B8%81%E0%B8%95%E0%B8%B2%E0%B9%84%E0%B8%97%E0%B8%A5%E0%B8%B7%E0%B9%89%E0%B8%AD%E0%B9%80%E0%B8%8A%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B8%84%E0%B8%B3-931654487032926/">https://www.facebook.com/ตุ๊กตาไทลื้อเชียงคำ</a>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            previewImage:[
                require('../../assets/product/cp3-1.jpg'),
                require('../../assets/product/cp3-2.jpg'),
                require('../../assets/product/cp3-3.jpg'),
                require('../../assets/product/cp3-4.jpg'),
                require('../../assets/product/cp3-5.jpg'),
                require('../../assets/product/cp3-6.jpg'),
                require('../../assets/product/cp3-7.jpg'),
                require('../../assets/product/cp3-8.jpg'),
                require('../../assets/product/cp3-9.jpg')
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/element-variables.scss";
#product{
  padding: 40px 10vw 40px 10vw;
   text-align: center;
   min-height: 20vw;
   h1{

      font-size: 30px;
      margin: 40px 0 10px 0;
    
    }
    .image-title {
        padding: 20px 0;
        .el-image{
            height: 400px;
        }
        @media (max-width: 767px) {
           .el-image{
                height: 200px;
            }
        }
    
    }
    .detail{
                text-align: justify;
        word-break: break-all;
        .indent{
            text-indent: 3em;
        }
        .q-title{
            font-weight: 600;
            margin-bottom: 10px;
            text-align: left; 
        }
        h3{
           text-align: left; 
        }
        a{
            cursor: pointer;
            color:$--color-text-primary;
            text-decoration:none;
        }
        a:hover {
         color:$--color-primary;
        }
        
        .card-product{
            padding: 10px 0;
            overflow: hidden;
            cursor: pointer;
            text-align: center;
            .el-image{
                height: 300px;
                width: 100%;
            }
           

            @media (max-width: 767px) {
                height: auto;
                padding: 10px 0;
            }
        }

        .card-product:hover{
            p{
                color:$--color-primary;
            }
        }
        
       .video{
           text-align: center;
       }
    }
}
</style>